import styled from "styled-components";

export const Title = styled.h1`
  font-size: 28px;
  font-weight: bold;
  margin-right: auto;
`;